// Date header formatting helper (like WhatsApp)
export const formatDateHeader = (dateStr, t) => {
    const d = new Date(dateStr);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (d.toDateString() === today.toDateString()) {
        return t ? t('range.Today') || "اليوم" : "اليوم";
    } else if (d.toDateString() === yesterday.toDateString()) {
        return t ? t('range.Yesterday') || "أمس" : "أمس";
    } else {
        return d.toLocaleDateString('ar-EG', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    }
};

// Clean bot HTML outputs (removes questions scripts and maps ** to bold tags)
export const cleanBotHtml = (html) => {
    if (!html) return "";
    let clean = html;
    const match = html.match(/<script\s+id=['"]lesson-questions-data['"]/i);
    if (match && match.index !== undefined) {
        clean = html.substring(0, match.index).trim();
    } else {
        clean = html.replace(/<script\s+id=['"]lesson-questions-data['"]\s+type=['"]application\/json['"]>[\s\S]*?<\/script>/gi, "").trim();
    }
    return clean.replace(/\*\*([\s\S]*?)\*\*/g, '<b>$1</b>');
};

// Escape user text and format double asterisks as bold tags
export const formatUserText = (text) => {
    if (!text) return "";
    const escaped = text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    return escaped.replace(/\*\*([\s\S]*?)\*\*/g, '<b>$1</b>');
};

// Pricing rates and calculation helper
export const calculateBreakdown = (agent, promptTokens, completionTokens) => {
    const isDeepSeek = agent && agent.toLowerCase().includes("deepseek");
    const promptRate = isDeepSeek ? 0.14 : 0.25;
    const completionRate = isDeepSeek ? 0.28 : 1.50;

    const promptCost = (promptTokens * promptRate) / 1000000;
    const completionCost = (completionTokens * completionRate) / 1000000;
    const totalCost = promptCost + completionCost;

    return {
        promptRate,
        completionRate,
        promptCost,
        completionCost,
        totalCost
    };
};

// Initials resolver helper
export const getInitials = (name, t) => {
    if (!name) return t ? t('Pages.DeepSeekAdmin.studentInitial') || "ط" : "ط";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
        return parts[0].substring(0, 1);
    }
    const firstLetter = parts[0].substring(0, 1);
    const lastLetter = parts[parts.length - 1].substring(0, 1);
    return (firstLetter + lastLetter).toUpperCase();
};

// Preceding prompt selector helper
export const getPrecedingPrompt = (botTurn, turns) => {
    const botIndex = turns.findIndex(t => t.Id === botTurn.Id);
    if (botIndex === -1) return "";
    for (let i = botIndex - 1; i >= 0; i--) {
        if (!turns[i].IsFromBot && turns[i].Prompt) {
            return turns[i].Prompt;
        }
    }
    return "";
};
